import React from 'react';
import { motion } from 'framer-motion';
import { Radio } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';
import { toYouTubeEmbed } from '../lib/youtube';

const StreamCard = ({ title, url, testId, delay }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay }}
    className="bg-white rounded-3xl shadow-sm border border-stone-100 overflow-hidden"
    data-testid={testId}
  >
    <div className="p-5 border-b border-stone-100">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 rounded-full bg-emerald-50 flex items-center justify-center">
          <Radio className="w-5 h-5 text-emerald-700" />
        </div>
        <div>
          <h3 className="text-lg font-body font-semibold text-text-primary">{title}</h3>
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" />
            <span className="text-xs font-body text-red-600 font-medium">LIVE 24/7</span>
          </div>
        </div>
      </div>
    </div>
    <div className="aspect-video bg-black">
      <iframe
        src={toYouTubeEmbed(url)}
        className="w-full h-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={title}
      />
    </div>
  </motion.div>
);

const StreamingPage = () => {
  const { settings } = useSettings();

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="min-h-screen bg-[#F8F9FA] px-6 py-8 pb-24">
      <div className="mb-8">
        <h1 className="text-4xl font-heading font-bold tracking-tight text-primary-dark mb-2">
          Live Streaming
        </h1>
        <p className="text-sm font-body text-text-secondary">
          Saksikan langsung dari Tanah Suci
        </p>
      </div>

      <div className="space-y-6">
        <StreamCard
          title="Masjidil Haram - Makkah"
          url={settings.streaming_makkah_url}
          testId="streaming-makkah"
          delay={0}
        />
        <StreamCard
          title="Masjid Nabawi - Madinah"
          url={settings.streaming_madinah_url}
          testId="streaming-madinah"
          delay={0.1}
        />
      </div>
    </motion.div>
  );
};

export default StreamingPage;
